module.exports = __webpack_public_path__ + "static/media/smartphone.2123ba41.png";